<template>
    <div>
        <div class="header-search">
            <a-input-search placeholder="请输入文档名称/操作人进行模糊搜索" style="width: 300px; margin:10px 20px 0 0;" @search="SearchList" />
            <a-select default-value="200" style="width: 200px" @change="selectChange">
                <a-select-option :key="200" value="200">全部</a-select-option>
                <a-select-option v-for="(item, index) in stateData" :key="index" :value="item.id">
                    {{item.name}}
                </a-select-option>
            </a-select>
        </div>

        <a-table class="tableStyle" :dataSource="data" :scroll="{ x: 1380 }" :pagination="pagination" :loading="loadingTable" @change="handleTableChange">
            <a-table-column title="ID" align="center" dataIndex="id" key="bookId" width="60px" fixed="left" />

            <a-table-column title="文档名称" key="name" width="170px" fixed="left">
                <template slot-scope="record">
                    <span>
                        <a class="alink" :disabled="record.isDownloadDisabled" href="javascript:;" @click="download(record)">{{record.name}}</a>
                    </span>
                </template>
            </a-table-column>

            <a-table-column title="学科" align="center" width="80px" dataIndex="courseName" key="courseName" />

            <a-table-column title="教辅来源" dataIndex="bookName" key="bookName" />

            <a-table-column title="上传者" dataIndex="createName" key="createName" />

            <a-table-column title="上传时间" align="center" dataIndex="createDate" defaultSortOrder='descend' :sorter='(a, b) => Date.parse(a.createDate) - Date.parse(b.createDate)' key="createDate" />

            <a-table-column title="状态" width="120px" defaultSortOrder='descend' :sorter="(a, b) => a.stateName.length - b.stateName.length">
                <template slot-scope="record">
                    <span>{{record.state != 2 && record.errorMessage ? record.errorMessage : record.stateName}}</span>
                </template>
            </a-table-column>

            <a-table-column title="操作人员" defaultSortOrder='descend' :sorter="(a, b) => a.editorName.length - b.editorName.length">
                <template slot-scope="record">
                    <span>{{record.editorName ? record.editorName : '-'}}</span>
                </template>
            </a-table-column>

            <a-table-column title="耗时" width="80px" dataIndex="costTime" defaultSortOrder='descend' :sorter='(a, b) => a.costTime - b.costTime' key="costTime" />

            <a-table-column title="题目数量" width="80px" align="center" dataIndex="questionCount" key="questionCount" />

            <a-table-column title="操作" align="center" key="operation" fixed="right" width="200px">
                <template slot-scope="record">
                    <span>
                        <a-tooltip placement="bottom">
                            <template slot="title">
                                <span>修改文档状态</span>
                            </template>
                            <a-button class="warning-button" size="small" icon="warning" :disabled="record.state == 1" @click="openDialog(record)"></a-button>
                        </a-tooltip>

                        <a-upload name="file" :showUploadList="false" :disabled="record.isUploadDisabled" :multiple="true" :action="upload.root + 'v1/learnonly/upload/upload1submit'" :headers="upload.headers" :data="uploadFormData" @change="handleChange">
                            <a-tooltip placement="bottom">
                                <template slot="title">
                                    <span>上传修改文档</span>
                                </template>
                                <a-button @click="getFromData(record)" :disabled="record.isUploadDisabled" class="success-button" size="small" icon="upload"></a-button>
                            </a-tooltip>
                        </a-upload>

                        <a-tooltip placement="bottom">
                            <template slot="title">
                                <span>解锁文档</span>
                            </template>
                            <a-button size="small" @click="UnlockFile(record)" :disabled="record.isUnlockFileDisabled" type="primary" icon="unlock"></a-button>
                        </a-tooltip>

                        <a-tooltip placement="bottom">
                            <template slot="title">
                                <span>修改文档</span>
                            </template>
                            <a-button type="primary" size="small" @click="oneFiledetail(record)" :disabled="record.isDetailFileDisabled" icon="form"></a-button>
                        </a-tooltip>
                    </span>
                </template>
            </a-table-column>
        </a-table>

        <a-modal title="修改文档状态" v-model="stateVisible" cancelText="取消" okText="提交" @ok="submitHandleOK">
            <a-form :form="stateFormData">
                <a-form-item label="文档状态" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                    <a-select v-model="stateFormData.stateid" @change="handleSelectChange" style="width: 180px;">
                        <template v-for="state in stateData">
                            <a-select-option :key="state.id" :value="state.id">{{state.name}}</a-select-option>
                        </template>
                    </a-select>
                </a-form-item>

                <a-form-item v-if="showErrorInput" label="错误信息" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                    <a-input v-model="stateFormData.errorMessage" style="width: 180px;" />
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
const data = []
const stateData = [
    { id: -1, name: '文档格式有误，请检查' },
    { id: 0, name: '等待系统解析' },
    { id: 1, name: '文档解析中' },
    { id: 2, name: '请设置题目属性' },
    { id: 3, name: '上传成功' },
]
export default {
    name: 'task',
    data () {
        return {
            data,
            loadingTable: true,
            stateData,
            formData: {
                start: '',
                length: '',
                keyword: '',
                state: 200
            },
            upload: {
                root: process.env.VUE_APP_BASE_API,
                headers: { authorization: this.$store.getters.token }
            },
            uploadFormData: {
                courseName: '',
                stageId: '',
                id: '',
            },
            pagination: {},
            stateVisible: false,
            stateFormData: {
                exerciseid: '',
                stateid: '',
                errorMessage: ''
            },
            showErrorInput: false,
        }
    },
    methods: {
        fetch () {
            this.loadingTable = true
            this.formData.start = this.pagination.current ? this.pagination.current : 1
            this.$http.get('v1/learnonly/upload/list/qeditor/ajax', { params: this.formData })
                .then(response => {
                    if (response) {
                        var listData = response.data.data
                        this.data = listData
                        for (let i = 0; i < listData.length; i++) {
                            this.data[i].index = i + 1
                            this.data[i].key = i.toString()

                            this.data[i].isDownloadDisabled = false
                            this.data[i].isStateDisabled = false
                            this.data[i].isUploadDisabled = false
                            this.data[i].isUnlockFileDisabled = false
                            this.data[i].isDetailFileDisabled = true
                        }

                        this.data = this.isDisabled(this.data)
                        // this.loadingTable = false
                        // this.pagination.total = response.data.recordsTotal


                        const pagination = { ...this.pagination };
                        // Read total count from server
                        // pagination.total = data.totalCount;
                        pagination.total = response.data.recordsTotal
                        this.loadingTable = false
                        this.pagination = pagination
                    }
                })
        },
        handleTableChange (pagination, filters, sorter) {
            // console.log(pagination)
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.fetch({
                results: pagination.pageSize,
                page: pagination.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
                ...filters,
            });
        },
        SearchList (value) {
            this.formData.keyword = value
            this.fetch()
        },
        selectChange (value) {
            console.log(value)
            this.formData.state = value
            this.fetch()
        },
        // changeState
        openDialog (data) {
            this.stateVisible = true
            this.stateFormData = {
                exerciseid: data.id,
                stateid: data.state,
                errorMessage: data.errorMessage
            }
            if (data.state == -1) {
                this.showErrorInput = true
            } else {
                this.showErrorInput = false
            }
        },

        handleSelectChange (value) {
            this.stateFormData.stateid = value
            if (value == -1) {
                this.showErrorInput = true
            } else {
                this.showErrorInput = false
            }
        },

        submitHandleOK () {
            this.stateVisible = false
            if (this.stateFormData.stateid == 2) {
                this.stateFormData.errorMessage = ""
            }
            this.$http.post('v1/learnonly/upload/detail/qeditor', this.stateFormData).then(response => {
                if (response.data === true) {
                    this.$message.success('状态修改成功！')
                } else {
                    this.$message.warning('状态已修改，不可重复修改状态')
                }
                this.fetch()
            })
        },
        // download
        download (data) {
            this.$http.get('v1/learnonly/upload/list/download/' + data.id, { responseType: 'arraybuffer' })
                .then(res => {
                    if (res.status == 200) {
                        let blob = new Blob([res.data], {
                            type: `application/msword` //word文档为msword,pdf文档为pdf
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        let link = document.createElement("a");
                        let fname = data.name + '.' + data.row_exerciseUrl.match(/([^.]+)$/)[1];
                        link.href = objectUrl;
                        link.setAttribute("download", fname);
                        document.body.appendChild(link);
                        link.click();
                    } else {
                        this.$message.error('下载失败')
                    }
                })
            this.updateEditName(data.id)
            this.changeState(data.id)
        },
        updateEditName (id) {
            this.$http.get('v1/learnonly/upload/list/checkDownload/' + id)
                .then(res => {
                    if (res.status == 200) {
                        this.fetch()
                    }
                })
        },
        changeState (id) {
            var para = {
                exerciseid: id,
                stateid: 1,
                errorMessage: '',
            }
            this.$http.post('v1/learnonly/upload/detail/qeditor', para).then()
        },
        // upload
        getFromData (data) {
            this.uploadFormData = {
                courseName: data.courseName.toString(),
                stageId: data.stageId,
                id: data.id,
            }
        },

        handleChange (info) {
            if (info.file.status === 'done') {
                if (info.file.response.result === true) {
                    this.$message.success(info.file.response.message)
                } else {
                    this.$message.warning(info.file.response.message)
                }
                this.fetch()
            }
        },
        // UnlockFile
        UnlockFile (data) {
            let that = this;
            if (data.editorName || data.downloadDate) {
                this.$confirm({
                    title: "确认解锁文档吗?",
                    okText: "确认",
                    okType: "danger",
                    cancelText: "取消",
                    onOk () {
                        that.$http.get('v1/learnonly/upload/list/unlockExercise/' + data.id).then(response => {
                            if (response.data == true) {
                                that.$message.success('解锁成功');
                                that.fetch()
                            }
                        })
                    }
                })
            } else {
                this.$message.success('该文件已是解锁状态！');
            }
        },
        // detail Page
        oneFiledetail (data) {
            let routeData = this.$router.resolve({ path: 'detail', query: data });
            window.open(routeData.href, '_blank');
        },
        // isDisabled
        isDisabled (data) {
            data.forEach(i => {
                if (i.editorName && i.editorName != this.$store.getters.name) {
                    i.isDownloadDisabled = true
                }
                if (i.state == 2 || i.state == 3) {
                    i.isUploadDisabled = true
                    i.isDetailFileDisabled = false
                }
            });
            return data
        },
    },
    created () {
        this.fetch()
    }
}
</script>
<style scoped>
.editable-row-operations a {
    margin-right: 8px;
}
.tableStyle tbody tr td {
    padding: 2px 10px;
}
/deep/.ant-table-pagination.ant-pagination {
    float: left;
}
</style>
